import { Area, InvitacionJurado } from "../../models/JuradosModel/jurados.model";
import { RegistrarJuradoModel } from "../../models/RegistrarJurado/registrarjurado.model";
import { BaseJuradosService } from "../base/baseApiJurados";

export class JuradosService extends BaseJuradosService {
  async saveSignature(docNumber: any, signature: any) {
    try {
      const { data } = await this.axiosClient.post(`/juries/save-signature/${docNumber}`, { signature });
      return data.ok;
    } catch (error) {
      throw new Error(`An unhandled exception in putAreasConocimiento with stack: ${error}`);
    }
  }

  async getJurados() {
    try {
      const { data } = await this.axiosClient.get(`/juries/`);
      return data.juries;
    } catch (error) {
      return console.error(`An unhandled exception in getJurados with stack: ${error}`);
    }
  }

  async getJurado(idJurado: any) {
    try {
      const { data } = await this.axiosClient.get(`/juries/${idJurado}`);
      return data.jury;
    } catch (error) {
      return console.error(`An unhandled exception in getJurados with stack: ${error}`);
    }
  }

  async getJuradobyId(idJurado: any) {
    try {
      const res = await this.axiosClient.get(`/juries/id/${idJurado}`);
      return res.data.jury;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async obetenerJuradoId(idJurado: string | number) {
    try {
      const { data } = await this.axiosClient.get(`/juries/obetenerJuradoId/${idJurado}`);
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in obetenerJuradoId with stack: ${error}`);
    }
  }

  async obetenerJuradoDocumento(documento: number) {
    try {
      const { data } = await this.axiosClient.get(`/juries/obetenerJuradoDocumento/${documento}`);
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in obetenerJuradoId with stack: ${error}`);
    }
  }

  async obetenerJuradoRadicado(radicado: string) {
    try {
      const { data } = await this.axiosClient.get(`/juries/obetenerJuradoRadicado/${radicado}`);
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in obetenerJuradoId with stack: ${error}`);
    }
  }

  async obetenerJuradoDoc(documento: string) {
    try {
      const { data } = await this.axiosClient.get(`/juries/obetenerJuradoDoc/${documento}`);
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in obetenerJuradoId with stack: ${error}`);
    }
  }

  async getJuryByDocNumber(docNumber: any) {
    try {
      const { data } = await this.axiosClient.get(`/juries/${docNumber}`);
      return data.jury;
    } catch (error) {
      return console.error(`An unhandled exception in getJurados with stack: ${error}`);
    }
  }

  /**
   * Igual que getJuryByDocNumber, pero deja salir el error en vez de devolver vacío.
   *
   * Así quien consulta puede distinguir "este documento no es jurado" de "no se pudo consultar":
   * antes las dos cosas llegaban como undefined y la pantalla mostraba el mismo aviso.
   */
  async consultarJuradoPorDocumento(docNumber: any) {
    const { data } = await this.axiosClient.get(`/juries/${docNumber}`);
    return data.jury;
  }

  async getCategorias(): Promise<Area[]> {
    try {
      const { data } = await this.axiosClient.get(`/areas/`);
      return data.areas;
    } catch (error) {
      throw new Error(`An unhandled exception in getCategorias with stack: ${error}`);
    }
  }

  async putAreasConocimiento(areasConocimiento: any, juradoId: number) {
    try {
      const { data } = await this.axiosClient.post(`/knowledges/${juradoId}`, areasConocimiento);
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in putAreasConocimiento with stack: ${error}`);
    }
  }
  async putEducacionFormal(arrayEducacionFormal: any, juradoId: any) {
    try {
      const { data } = await this.axiosClient.post(`/formal-education/${juradoId}`, arrayEducacionFormal);
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in putEducacionFormal with stack: ${error}`);
    }
  }

  async putEducacionNoFormal(arrayEducacionNoFormal: any, juradoId: number) {
    try {
      const { data } = await this.axiosClient.post(`/informal-education/many/${juradoId}`, {
        items: arrayEducacionNoFormal,
      });
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in putEducacionFormal with stack: ${error}`);
    }
  }

  async getAreas() {
    try {
      const { data } = await this.axiosClient.get(`/areas/`);
      return data.areas;
    } catch (error) {
      throw new Error(`An unhandled exception in getAreas with stack: ${error}`);
    }
  }

  async guardarInformarcionjurados(jurado: RegistrarJuradoModel) {
    try {
      const { data } = await this.axiosClient.post(`/juries/`, jurado);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarInformarcionjurados with stack: ${error}`);
    }
  }

  async actualizarjurado(jurado: RegistrarJuradoModel) {
    try {
      const { data } = await this.axiosClient.put(`/juries/updateBydocument/${jurado.numero_documento}`, jurado);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarInformarcionjurados with stack: ${error}`);
    }
  }


  async ActualizarInformarcionJurado(idJurado: string, jurado: RegistrarJuradoModel) {
    try {
      const { data } = await this.axiosClient.put(`/juries/${idJurado}`, jurado);
      return data.jury;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarInformarcionjurados with stack: ${error}`);
    }
  }

  async guardarInformarcionjuradosreconocimientos(idJurado: string, reconocimientos: any) {
    try {
      const { data } = await this.axiosClient.post(`/acknowledgments/${idJurado}`, {
        items: reconocimientos,
      });
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarInformarcionjuradosreconocimientos with stack: ${error}`);
    }
  }

  async guardarInformarcionjuradospublicaciones(idJurado: string, publicaciones: any) {
    try {
      const { data } = await this.axiosClient.post(`/publications/${idJurado}`, publicaciones);
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarInformarcionjuradospublicaciones with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async guardarExperienciaJurado(idJurado: string, experiencias: any) {
    try {
      const { data } = await this.axiosClient.post(`/jury-experience/${idJurado}`, experiencias);
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in getCategorias with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async guardarExperienciaProfesional(idJurado: string, experiencias: any) {
    try {
      const { data } = await this.axiosClient.post(`/professional-experience/many/${idJurado}`, {
        items: experiencias,
      });
      return data.updatedJury;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerExperiencias(idJurado: string) {
    try {
      const { data } = await this.axiosClient.get(`/jury-experience/jury/${idJurado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerPublicaciones(idJurado: string) {
    try {
      const { data } = await this.axiosClient.get(`/publications/jury/${idJurado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerReconocimientos(idJurado: string) {
    try {
      const { data } = await this.axiosClient.get(`/acknowledgments/jury/${idJurado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerReconocimientosProfesionales(idJurado: string) {
    try {
      const { data } = await this.axiosClient.get(`/professional-experience/jury/${idJurado}`);
      return data.professional_experiences;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerEducacionNoFormal(idJurado: string) {
    try {
      const { data } = await this.axiosClient.get(`/informal-education/jury/${idJurado}`);
      return data.informalEducations;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  // Se recibe el ID del jurado en lugar del numero de documento
  async obtenerEducacionFormal(idJurado: any) {
    try {
      const { data } = await this.axiosClient.get(`/formal-education/jury/${idJurado}`);
      return data.formalEducations;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarExperienciaJurado with stack: ${error}`);
    }
  }

  async obtenerAreasCategoriasJurado(idJurado: number) {
    try {
      const { data } = await this.axiosClient.get(`/knowledges/jury/${idJurado}`);
      return data.knowledges;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerAreasCategoriasJurado with stack: ${error}`);
    }
  }

  async invitacionJurado(invitacion: InvitacionJurado) {
    try {
      await this.axiosClient.post(`${process.env.REACT_APP_SERVER_JURA2}email`, invitacion);
    } catch (error) {
      throw new Error(`An unhandled exception in invitacionJurado with stack: ${error}`);
    }
  }

  async guardarPostulacionesJurado(values: any) {
    try {
      let data = await this.axiosClient.post(`/projects/assign`, values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in invitacionJurado with stack: ${error}`);
    }
  }

  async consultarProjectosJurados() {
    try {
      let data = await this.axiosClient.get(`/juries/obtenerJuradosConProyectos`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in invitacionJurado with stack: ${error}`);
    }
  }

  async actualizarCriterioJurado(values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/criterios/actualizarCriterio/${values.id}`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }



  async obtenerCriterioJurado(idJurado: number) {
    try {
      let { data } = await this.axiosClient.get(`/criterios/obtenerCriteriosJurados/${idJurado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }
  async obtenerCriteriosPostulacion(id_postulacion: number) {
    try {
      let { data } = await this.axiosClient.get(`/criterios/obtenerCriteriosPostulacion/${id_postulacion}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }

  async obtenerCriterioProyectoJurado(numero_documento: string) {
    try {
      let { data } = await this.axiosClient.get(`/juries/obtenerJuradosConCriteriosyProyectos/${numero_documento}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }

  async obtenerCriterioHojadeVidaJurado(numero_documento: string) {
    try {
      let { data } = await this.axiosClient.get(`/juries/obtenerJuradosConCriteriosyProyectosJuries/${numero_documento}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }

  async obtenerProyectosJuradosCriterios() {
    try {
      let { data } = await this.axiosClient.get(`/juries/obtenerProjectosConJuradosyCriterios`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }
  async obtenerProyectosJuradosCriteriosReporte() {
    try {
      let { data } = await this.axiosClient.get(`/juries/obtenerProjectosConJuradosyCriterios/reporte`, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }
  async juradosReporte(estado: string, fechaInicio: string, fechaFin: string) {
    try {
      let { data } = await this.axiosClient.get(`/juries/report/${estado}/${fechaInicio}/${fechaFin}`, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarFoto with stack: ${error}`);
    }
  }

  async getAllPostulacionesPagos() {
    try {
      const { data } = await this.axiosClient.get(`/projects/pagosJurados`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getCategoriasLineaConvocatoria with stack: ${error}`);
    }
  }


  async desahabilitarProject(id_jurado: number, id_postulacion: number) {
    try {
      const { data } = await this.axiosClient.put(`/projects/desahabilitarProject/${id_jurado}/${id_postulacion}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in desahabilitarProject with stack: ${error}`);
    }
  }

  async obtenerHistorialJurado(documentoJurado: any) {
    try {
      const { data } = await this.axiosClient.get(`/juries/historialEvaluacionJurado/${documentoJurado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerHistorialJurado with stack: ${error}`);
    }
  }

  async adjutarDocumento(juradoId: any, payload: any) {
    //
    try {
      const { data } = await this.axiosClient.post(`/projects/adjutarDocumento/${juradoId}`, payload);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerHistorialJurado with stack: ${error}`);
    }
  }

  async cambiarEstadoJurado(juradoId: any, status: any) {
    //
    try {
      const { data } = await this.axiosClient.put(`/juries/status/change/${juradoId}`, { status });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarEstadoJurado with stack: ${error}`);
    }
  }

  async obtenerCriteriosJuradoPostulacion(jury_id: any, postulacion_id: any) {
    //
    try {
      const { data } = await this.axiosClient.get(`/criterios/obtenerCriteriosJuradoPostulacion/${jury_id}/${postulacion_id}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarEstadoJurado with stack: ${error}`);
    }
  }

  async eliminarCriterio(id: any) {
    try {
      const { data } = await this.axiosClient.delete(`/criterios/eliminarCriterio/${id}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarEstadoJurado with stack: ${error}`);
    }
  }

  async eliminarAsignacion(jury_id: any, project_id: any) {
    try {
      const { data } = await this.axiosClient.delete(`/projects/eliminarAsignacion/${jury_id}/${project_id}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarEstadoJurado with stack: ${error}`);
    }
  }


  async obtenerIdJurado(documento: any) {
    try {
      const { data } = await this.axiosClient.get(`/juries/obtenerIdJurado/${documento}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarEstadoJurado with stack: ${error}`);
    }
  }

  async enviarHojaVidaJurado(id_jurado: any) {
    try {
      const { data } = await this.axiosClient.put(`/juries/enviarHojaVidaJurado/${id_jurado}`);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }


}




export default new JuradosService();
